import TagInputs from "./TagInputs";

const ContactPerson = ({handleSubmit, contactPersonPayload, setContactPersonPayload}) => {

    const handleChange = (e) => {
        setContactPersonPayload({...contactPersonPayload, [e.target.name]: e.target.value})
    }


    return (
        <div className="w-30">
            <div>
                <TagInputs value = {contactPersonPayload?.firstName} name = "firstName" onChange = {handleChange} type='text' label='First Name' />
                <TagInputs value = {contactPersonPayload?.lastName} name = "lastName" onChange = {handleChange} type='text' label='Last Name' />
                <TagInputs value = {contactPersonPayload?.designation} name = "designation" onChange = {handleChange} type='text' label='Designation' />
                <TagInputs value = {contactPersonPayload?.phoneNumber} name = "phoneNumber" onChange = {handleChange} type='text' label='Phone Number' />
                <TagInputs value = {contactPersonPayload?.email} name = "email" onChange = {handleChange} type='text' label='Email' />
            </div>
            {/* <p className="right-text">
                Add another Contact
            </p> */}
        </div>

    )
}

export default ContactPerson;